<script setup>
// Config do node "Nota": anotação visual no canvas (pro builder). Não afeta o
// agente — é só uma observação no fluxo. Cor ajuda a organizar visualmente.
import { useI18n } from 'vue-i18n';

const props = defineProps({ data: { type: Object, required: true } });
const emit = defineEmits(['update', 'remove', 'close']);
const { t } = useI18n();

const COLORS = [
  '#9aa0a6',
  '#f9ab00',
  '#34a853',
  '#4285f4',
  '#ea4335',
  '#7e57c2',
];
const current = () => props.data.color || '#9aa0a6';
</script>

<template>
  <div class="p-4">
    <div class="mb-1 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <span class="i-lucide-sticky-note text-n-slate-11" />
        <h3 class="text-sm font-semibold text-n-slate-12">
          {{ data.label || t('AI_AGENTS.FLOW.NOTE.TITLE') }}
        </h3>
      </div>
      <button class="i-lucide-x text-n-slate-10" @click="emit('close')" />
    </div>
    <p class="mb-3 text-xs text-n-slate-10">
      {{ t('AI_AGENTS.FLOW.NOTE.SUBTITLE') }}
    </p>

    <textarea
      :value="data.content"
      rows="5"
      :placeholder="t('AI_AGENTS.FLOW.NOTE.CONTENT_PH')"
      class="mb-3 w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm"
      @input="emit('update', { content: $event.target.value })"
    />

    <label class="mb-1 block text-xs font-medium text-n-slate-11">
      {{ t('AI_AGENTS.FLOW.NOTE.COLOR') }}
    </label>
    <div class="flex gap-2">
      <button
        v-for="c in COLORS"
        :key="c"
        type="button"
        class="size-6 rounded-full border-2 transition-transform hover:scale-110"
        :class="current() === c ? 'border-n-slate-12' : 'border-transparent'"
        :style="{ backgroundColor: c }"
        @click="emit('update', { color: c })"
      />
    </div>

    <button
      class="mt-4 w-full rounded-lg border border-n-ruby-7 py-2 text-sm font-medium text-n-ruby-9 hover:bg-n-ruby-3"
      @click="emit('remove')"
    >
      {{ t('AI_AGENTS.FLOW.REMOVE_NODE') }}
    </button>
  </div>
</template>
